import React, { forwardRef, useMemo } from "react";
import { NavbarItems } from "./constants/Dropdown.constants.tsx";
import RotaItem from "./components/DropdownRotaItem.tsx";
import {
  FinanceiroItemsEnum,
  NavbarItemsEnum,
} from "./interfaces/Dropdown.enum.ts";
import DropdownSection from "./components/DropdownSection.tsx";
import DropdownSectionCombined from "./components/DropdownSectionCombined.tsx";

interface DropdownPrecificacaoProps {
  ref: React.RefObject<HTMLDivElement>;
}

const DropdownPrecificacao = forwardRef<
  HTMLDivElement,
  DropdownPrecificacaoProps
>(({}, ref) => {
  const FinanceiroSections = NavbarItems[NavbarItemsEnum.FINANCEIRO].sections;

  const cotacaoItems = FinanceiroSections[FinanceiroItemsEnum.COTACAO].items;

  const faturamentoItems =
    FinanceiroSections[FinanceiroItemsEnum.FATURAMENTO].items;

  const precificacaoItems =
    FinanceiroSections[FinanceiroItemsEnum.PRECIFICACAO].items;

  const memorizedCotacaoItems = useMemo(() => {
    return cotacaoItems.map((item) => (
      <div key={`cotacao-${item.rota}`} className="botao-menu-cte">
        <RotaItem key={`cotacao-${item.rota}`} item={item} />
      </div>
    ));
  }, [cotacaoItems]);

  const memorizedFaturamentoItems = useMemo(() => {
    return faturamentoItems.map((item) => (
      <div key={`faturamento-${item.rota}`} className="botao-menu-cte">
        <RotaItem key={`faturamento-${item.rota}`} item={item} />
      </div>
    ));
  }, [faturamentoItems]);

  const memorizedPrecificacaoItems = useMemo(() => {
    return precificacaoItems.map((item) => (
      <div key={`precificacao-${item.rota}`} className="botao-menu-cte">
        <RotaItem key={`precificacao-${item.rota}`} item={item} />
      </div>
    ));
  }, [precificacaoItems]);

  return (
    <div ref={ref} className="dropdown-content-emb">
      <div className="separador-menu-financeiro" />
      <div className="content-menu-rows">
        <DropdownSection
          titleSection={
            FinanceiroSections[FinanceiroItemsEnum.PRECIFICACAO].titleSection
          }
          icon={FinanceiroSections[FinanceiroItemsEnum.PRECIFICACAO].icon}
        >
          {memorizedPrecificacaoItems}
        </DropdownSection>
        <DropdownSection
          titleSection={
            FinanceiroSections[FinanceiroItemsEnum.COTACAO].titleSection
          }
          icon={FinanceiroSections[FinanceiroItemsEnum.COTACAO].icon}
          children={memorizedCotacaoItems}
        />
        <DropdownSection
          icon={FinanceiroSections[FinanceiroItemsEnum.FATURAMENTO].icon}
          titleSection={
            FinanceiroSections[FinanceiroItemsEnum.FATURAMENTO].titleSection
          }
          children={memorizedFaturamentoItems}
        />
      </div>
    </div>
  );
});

export default DropdownPrecificacao;
